import { Text } from '@chakra-ui/react';

interface RecencyGroupHeadingProps {
	label: string;
}

/** The small uppercase label over a Today / Yesterday / Earlier section in a list. */
function RecencyGroupHeading(props: RecencyGroupHeadingProps) {
	const { label } = props;

	return (
		<Text
			px={4}
			pt={4}
			pb={2}
			textStyle="micro"
			fontWeight="semibold"
			color="fg.muted"
			textTransform="uppercase"
			letterSpacing="0.04em"
		>
			{label}
		</Text>
	);
}

export default RecencyGroupHeading;
